import React, { useEffect, useState } from 'react';
import { Grid, Card, CardActionArea, CardContent, Typography } from '@mui/material';

// function Redemption(data) {
// 
//   let redemptionData = [];
//   if (data !== undefined) {
//     redemptionData.push(
//       <Grid container style={{
//         justifyContent: "center",
//         border: 1,
//         borderRadius: 30,
//         backgroundColor: "orange",
//         padding: 5,

//       }}>
//         {data.map((value) => (
//           <Grid key={value} item>
//             {value === "Exchange" ?
//               <Tooltip title={value}>
//                 <Grid style={{
//                   margin: 5
//                 }}>
//                   <span className="material-icons">
//                     currency_exchange
//                   </span>
//                 </Grid>
//               </Tooltip>
//               : value === "Gift" ?
//                 <Tooltip title={value}>
//                   <Grid style={{
//                     margin: 5
//                   }}>
//                     <span className="material-icons">
//                       card_giftcard
//                     </span>
//                   </Grid>
//                 </Tooltip>
//                 :
//                 <Tooltip title={value}>
//                   <Grid style={{
//                     margin: 5
//                   }}>
//                     <span className="material-icons">
//                       card_membership
//                     </span>
//                   </Grid>
//                 </Tooltip>

//             }

//           </Grid>
//         ))}
//       </Grid>
//     )
//   }

//   return redemptionData;
// }
function ProgramData(data) {
  let returnTableBody = [];
  for (let index = 0; index < data.length; index++) {
    returnTableBody.push(
      <>
        <div className='card'>
          <Card
            variant='outlined'
            style={{
              borderRadius: 30,
              marginTop: 20,
              marginLeft: 20,
              marginRight: 20,
              outlineColor: 'black',
            }}
            onClick={() => {
              window.location.href = `/program/${data[index].ProgramId}`;
            }}
          >
            <CardActionArea>
              <CardContent style={{ fontFamily: 'Raleway' }}>
                <Grid container>
                  <Grid xs={9} sm={9} md={9}>
                    <Grid container>
                      <Grid item xs={7} md={9}>
                        <Typography
                          component='h1'
                          style={{
                            fontSize: 22,
                            fontFamily: 'Raleway',
                          }}
                        >
                          <strong>{data[index].ProgramName}</strong>
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          component='h5'
                          style={{
                            color: 'black',
                            fontFamily: 'Raleway',
                          }}
                        >
                          Description: {data[index].ProgramDescription}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}></Grid>
                      <Grid item xs={12}>
                        <Typography
                          component='h5'
                          style={{
                            color: 'black',
                            fontFamily: 'Raleway',
                          }}
                        >
                          Start Date: {data[index].StartDate}
                        </Typography>
                      </Grid>
                      <Grid item xs={11}>
                        <Typography
                          component='h5'
                          style={{
                            color: 'black',
                            fontFamily: 'Raleway',
                          }}
                        >
                          Founder : {data[index].FounderName}
                        </Typography>
                      </Grid>

                    </Grid>
                  </Grid>

                  {/* <Grid xs={3} sm={3} md={3} >
                   {Redemption(data[index].Redemption)}
                  </Grid> */}


                </Grid>
              </CardContent>
            </CardActionArea>
          </Card>
          <Grid item xs={12}></Grid>
          <Grid
            item
            xs={12}
            md={4}
            style={{
              display: 'inline-flex',
              float: 'right',
            }}
          ></Grid>
        </div>
      </>
    );
  }
  return returnTableBody;
}
export default function AllProgramsWithoutAuth() {
  const [allPrograms, setAllPrograms] = useState([]);
  useEffect(() => {
    let endPoint = `/api/programs/list/view`
    fetch(process.env.REACT_APP_API_URL + endPoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAllPrograms(data.response.response_data)

      }).catch(err => {
        //console.log(err)
      });

  }, [])
  if (allPrograms) {
    return (
      <Grid container style={{}}>
        <Grid item md={3}></Grid>
        <Grid item xs={12} md={6}>
          {ProgramData(allPrograms)}
        </Grid>
      </Grid>
    );
  }
} 